import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Checkbox } from '@els/els-react--checkbox';
import { absoluteIndexToString } from '@Containers/PatentFamilyClustering/utils';
import {
  isResultChecked as isResultCheckedSelector,
  isResultCheckedPartial as isResultCheckedPartialSelector,
} from '@Pages/Results/selectors';
import { setResultChecked as setResultCheckedAction } from '@Pages/Results/actions';

import './ResultCheckboxContainer.scss';

export function ResultCheckbox({ result, context, isChecked, isPartial, setResultChecked }) {
  const { title, index, absoluteIndex } = result;
  // Generic results
  let indexStr = index;

  // Patent Family Clustering
  if (absoluteIndex) {
    indexStr = absoluteIndexToString(absoluteIndex);
  }

  return (
    // rx-element-checkbox
    <div className="result-checkbox-container u-els-padding-top">
      <Checkbox
        data-e2e={`result-checkbox-${indexStr}`}
        id={`element-${indexStr}`}
        title={`Select result number ${title || indexStr}`}
        label={`Select result number ${indexStr}`}
        shouldHideLabel
        className="result-checkbox"
        checked={isChecked}
        indeterminate={isPartial}
        onChange={() => setResultChecked(result, !isChecked, context)}
      />
      {/* rx-element-index */}
      {indexStr && <div className="u-els-font-size-meta u-els-color-n8 u-els-text-center">{indexStr}</div>}
    </div>
  );
}

ResultCheckbox.propTypes = {
  result: PropTypes.object.isRequired,
  context: PropTypes.string,
  isChecked: PropTypes.bool,
  isPartial: PropTypes.bool,
  setResultChecked: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { result }) => ({
  isChecked: isResultCheckedSelector(state, result),
  isPartial: isResultCheckedPartialSelector(state, result),
});

const mapDispatchToProps = {
  setResultChecked: setResultCheckedAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultCheckbox);
